import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import Close from "@store/Library/Components/Icons/Close";
import { buttonResetStyles } from "@store/Themes/common/mixins/button";
import { css } from "styled-components";

const tag: Styleguide["tag"] = {
    gap: pxToRem(10),
    defaultProps: {
        typographyProps: {
            css: css`
                /* white-space: nowrap; */
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            src: Close,
            size: 13,
            color: "inherit",
        },
        css: css`
            min-height: 0;
            align-items: center;
            padding: ${pxToRem(7, 12)};
            margin: 0;
            border-radius: ${pxToRem(4)};
            background-color: ${getColor("common.accent")};
            color: ${getColor("common.accentContrast")};

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smaller};
                line-height: ${theme.design.typography.lineHeight.small};
            `}

            button {
                ${buttonResetStyles()}
                flex: 0 0 auto;
                width: 1.3em;
                height: 1.3em;
                margin: ${pxToRem(0, -4, 0, 6)};
                color: ${getColor("common.borderDark")}; /* Store Custom Code */
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
};

export default tag;
